import axios from 'axios';

const getBaseUrl = () => {
  const host = window.location.hostname;

  // Local dev on machine
  if (host === 'localhost' || host === '127.0.0.1') {
    return 'http://localhost:6500/api';
  }

  // Your LAN IP for phone testing
  if (host.startsWith('192.168.1.')) {
    return `http://${host}:6500/api`;
  }

  // Production
  return 'https://apiviztech.in:6500/api';
};

const api = axios.create({
  baseURL: getBaseUrl(),
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('jwtToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
export function printBill(billId) {
  return api.get(`/print/${billId}`);
}
